<template>
  <div class="chatbot-answer-choices-horizontal">
    <button
      v-for="choice in choices"
      :key="choice.id"
      v-on:click="sendChoiceAnswer(choice)"
      :style="{ borderColor: config.choicesColor, color: config.choicesColor }"
    >
      {{ choice.displayText }}
    </button>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "AnswerChoicesHorizontal",
  computed: {
    ...mapState("messages", ["choices"]),
    ...mapState("settings", ["config"])
  },
  methods: {
    ...mapActions("messages", ["sendChoiceAnswer"])
  }
};
</script>

<style lang="scss" scoped>
.chatbot-answer-choices-horizontal {
  display: block;
  overflow: auto;
  white-space: nowrap;
  padding: 10px 10px;

  button {
    font-size: 1rem;
    border: 2px solid;
    outline: 0;
    border-radius: 30px;
    padding: 15px;
    min-width: 39px;
    margin-right: 5px;
    cursor: pointer;
  }
}
</style>
